// TSS vite/03 §"Query keys".

export const planningKeys = {
    all:  ['opu-planning'],
    plan: (params) => ['opu-planning', 'plan', params],
};
